const getColor = (count) => {
  if (count < 10) return "#9CB6E4"; // light blue
  if (count < 50) return "#83A4DD"; // medium blue
  return "#6D93D7"; // dark blue
};

const LockersClustererIcon = ({ markersLibrary }) => ({
  render({ count, position }) {
    const div = document.createElement("div");
    const span = document.createElement("span");

    const bgColor = getColor(count);

    span.style.backgroundColor = bgColor;
    span.style.color = "#ffffff";
    span.style.borderRadius = "9999px";
    span.style.width = "36px";
    span.style.height = "36px";
    span.style.display = "flex";
    span.style.alignItems = "center";
    span.style.justifyContent = "center";
    span.style.fontSize = "13px";
    span.style.fontWeight = "600";
    span.textContent = count;

    // Set box-sizing so border doesn't affect size
    div.style.boxSizing = "border-box";

    div.style.backgroundColor = "rgba(131, 164, 221, 0.5)";
    div.style.borderRadius = "9999px";
    div.style.padding = "8px";

    div.appendChild(span);

    return new markersLibrary.AdvancedMarkerElement({
      position,
      content: div,
    });
  },
});

export default LockersClustererIcon;
